import React, { useState } from 'react'
import {
  Box,
  Button,
  Field,
  Flex,
  Heading,
  Message,
  Modal,
  Text,
  toast,
} from '@workwhile/ui'
import { useCompanyDetailWorkflowsContextValue } from '../../../context/CompanyDetailWorkflowProvider'
import { useUploadCompanyFileFlowContextValue } from '../context/UploadCompanyFileFlowProvider'

export const UploadCompanyFileFlowMain = () => {
  const {
    uploadCompanyFileFlow: { isOpen, close },
  } = useCompanyDetailWorkflowsContextValue()
  const {
    state: {
      mutationState: { isPending, errorMessage },
    },
    actions: { submit, reset: resetMutation },
  } = useUploadCompanyFileFlowContextValue()

  const [files, setFiles] = useState<FileList | null>(null)

  const handleClose = () => {
    setFiles(null)
    resetMutation()
    close()
  }

  const handleSubmit = () => {
    if (!files || files.length === 0) {
      toast.error('Select at least one PDF file')
      return
    }

    submit(Array.from(files), {
      onSuccess: () => {
        toast.success('Uploaded company file(s)')
        handleClose()
      },
      onError: (error) => {
        toast.error(error.message || 'Failed to upload company file(s)')
      },
    })
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      position="top"
      loading={isPending}
      showCancel
      customCta={
        <Flex>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Upload
          </Button>
        </Flex>
      }
    >
      <Box>
        <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
          Upload Company File
        </Heading>
        <Text mt={2} fontSize={1} color="lightText">
          PDFs are stored in the company&apos;s `public/` bucket and can be
          selected in the Business Portal Position Tutorial or Shift
          Instructions.
        </Text>
        <Field
          label="PDF file(s)"
          // @ts-expect-error - mt is not a valid prop for Field
          mt={3}
        >
          <input
            type="file"
            accept="application/pdf,.pdf"
            multiple
            onChange={(event) => setFiles(event.target.files)}
          />
        </Field>
        {errorMessage ? (
          <Message variant="error" mt={3} borderRadius="small">
            {errorMessage}
          </Message>
        ) : null}
      </Box>
    </Modal>
  )
}
